import React,{useEffect, useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress, TextField, InputAdornment, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import MoreIcon from '@mui/icons-material/MoreVert'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { Add, CalendarMonth, CopyAll, EditNote, Groups, Mail, Person3Outlined, Remove, Timelapse } from '@mui/icons-material';
import { Editor } from "primereact/editor";
import EditorText from '../Components/EditorText';
import DestDialog from '../Components/DestDialog'
import ListDialog from '../Components/ListDialog'

const SendMail = ()=>{


	const theme = useTheme()
	const [subject, setSubject] = useState("");
	const [content, setContent] = useState("");
	const navigate = useNavigate()
	const [loading, setLoading] = useState(false);
	const [deleting, setDeleting] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [showModal, setShowModal] = React.useState(false);
	const [showAdd, setShowAdd] = React.useState(false);
	const [message, setMessage] = React.useState("");
	const [email, setEmail] = React.useState("");
	const user = useSelector(state => state?.auth.user);
	const test = useSelector(state => state?.test.test);
	const assessment = useSelector(state => state?.templates.assessment);
	const candidates = useSelector(state => state?.setting.candidates);
	const [users, setUsers] = React.useState(candidates || []);
	const dispatch = useDispatch()


const handleSend = async ()=>{
	try {
		if (users?.length > 0) {
			
			setLoading(true)

			const send_data = {
				destinations:users,
				subject:subject,
				content:content
			}

			const sendMail = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}send-mail/`,send_data,{
				headers:{
						"Content-Type":"application/json",
						"Authorization":`Bear ${user?.accessToken}`
					}
			}).catch(err=>{
				setLoading(false)
				setMessage("connection error")
				setOpen(true)
			})

			if (sendMail?.status == 200 && sendMail?.data?.success) {
				setMessage(sendMail?.data?.message)
				setOpen(true)
			} else {
				setMessage(sendMail?.data?.message)
				setOpen(true)
			}
			setLoading(false)
		} else {
			setMessage("please, add destinations")
			setOpen(true)
		}
	} catch (error) {
		console.log(error)
	}
}

const handleAdd = async ()=>{
	try {
		if (email !== "") {
			setUsers(prev=>[...prev,{email:email}])
			setEmail("")
		} else {
			setMessage("please, add email address")
			setOpen(true)
		}
	} catch (error) {
		console.log(error)
	}
}

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography  sx={{fontSize:12,color:"gray"}}>Send Mail</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={()=>{
                        setOpen(false)
                    }} 
					open={open} 
					autoHideDuration={8000}
				/>
				<Box  sx={{backgroundColor:"black",borderRadius:5,padding:2,width:{xs:450,md:"100%",paddingLeft:1}}}>
					<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="flex-start">
						<Typography mt={1} mb={5} ml={5} style={{fontSize:16,fontWeight:400,fontFamily:"dinofans"}}>
							Send mail
						</Typography>
						<Box display="flex" flexDirection="row">
							<IconButton  onClick={()=>setShowModal(true)}>
								<Typography mr={1}>{users?.length}</Typography>
								<Person3Outlined fontSize="small"/>
							</IconButton>
							<IconButton  onClick={()=>setShowAdd(true)}>
								<Add fontSize="small"/>
							</IconButton>
						</Box>
					</Box>
					<Box m={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            Subject
                        </Typography> 
                        <TextField
                            label="subject"
                            onChange={(e)=>{setSubject(e.target.value)}}
                            placeholder='subject...'
                            type="text"
                            required
                            sx={{minWidth:280}}
                            value={subject}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <Mail /> 
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box> 
					<Box m={1} mt={2}>
						<Box width="100%">
							<EditorText
								title="Content"
								data={content}
								setData={setContent}
								width="95%"
								label="Content"
								isRequired={true}
							/>
						</Box>
                    </Box> 
					<Box m={1}>
						<Button sx={{background:"#FFF",fontFamily:"dinofans",fontSize:12,marginTop:2,color:"#000"}} disabled={loading} onClick={handleSend} >
							{
								loading ? <CircularProgress size={20} style={{color:"#000"}}/> : "SEND"
							}
						</Button>
                    </Box> 
				</Box>
				<DestDialog visible={showAdd} setVisible={setShowAdd} handleAdd={handleAdd} setData={setEmail} data={email}/>
				<ListDialog visible={showModal} setVisible={setShowModal}  data={users} setData={setUsers}/>
			</Container>
		</Box>
		)
}

export default SendMail